import React, {useEffect, useState} from 'react'
import {toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import {IProfileDetails, profileDetailsInitValues as initialValues} from '../SettingsModel'
import { fetchData, fetchFormData, toasterrormsg, toastsuccessmsg } from '../../../../../../reusable'
import PhoneInput from 'react-phone-input-2'
import { ToastContainer } from 'react-toastify'


const ProfileDetails: React.FC = () => {
  var tmp:any=sessionStorage.getItem("vendor")
  tmp=JSON.parse(tmp)

  const [data, setData] = useState<IProfileDetails>(initialValues)
  

  const [loading, setLoading] = useState(false)
  const [adminData,setadminData]=useState(Object)

    //overview states
    const [fullName,setFullName]=useState("");
    const [countryCode, setCountryCode] = useState('');
    const [mobileNumber,setMobileNumber]=useState("");
    const [email,setEmail]=useState("");
   


    //profile state
    const [image,setImage]=useState()
    const [imageUrl,setImageUrl]=useState("");

    const handleChange = (value:any, country:any,e:any,formate:any) => {
      
        const parts = formate.split(' ');
        const formattedValue = parts.slice(1).join(' ').replace(/\D/g, ""); 
        
        
        setCountryCode(country.dialCode); // get country code
        setMobileNumber(formattedValue); // get mobile number without country code
    };
    {sessionStorage.getItem("vendor")}
    
    // action function start
    const validprofile=()=>{
        var err=0
        if((image==null || image==undefined)&& (imageUrl==="" || imageUrl===null))
        {
            toasterrormsg("Image Required")
            err=1
        }
        else if(fullName.trim()==="" || fullName.trim()==null || fullName.trim()===undefined)
        {
            toasterrormsg("Full Name Required")
            err=1
        }
        if(mobileNumber.trim()==="" || mobileNumber.trim()==null || mobileNumber.trim()===undefined)
        {
            toasterrormsg("Mobile Number Required")
            err=1
        }
        else if(!mobileNumber.match(/^\d+$/) || mobileNumber.length>13 || mobileNumber.length<6)
        {
            toasterrormsg("Enter Valid Mobile Number")
            err=1
        }
        else if(email.trim()==="" || email.trim()==null || email.trim()===undefined)
        {
            toasterrormsg("Email Required")
            err=1
        }
        else if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}(?:\.[A-Z]{2,})?$/i.test(email))
        {
            toasterrormsg("Enter Valid Email")
            err=1
        }
  
        if(err==0)
        {
            callupdateprofile()
        }
    }

    // call update profile API
    const callupdateprofile = async() =>{
       
        let param = new FormData()

        param.append('adminId', String(adminData['adminId']))
        param.append('fullName', fullName)
        param.append('countryCode', countryCode)
        param.append('mobileNumber', mobileNumber)
        param.append('email', email)
  
        if(image){
            param.append('profilePicture', image)
        }

        var res=await fetchFormData("admin/updateProfile",param)        
        if(res.status=="200")
        {
          var data=res.data[0]
          var tmp:any=sessionStorage.getItem("admin")
          tmp=JSON.parse(tmp)
          tmp['fullName']=data.fullName
          tmp['mobile_number']=data.mobileNumber
          tmp['email']=data.email
          tmp['profilePicture']=data['profilePicture']
          tmp['country_code']=data.countryCode

          sessionStorage.setItem("admin",JSON.stringify(tmp))
            toastsuccessmsg("Profile Updated Successfully")
            setLoading(true);
            setTimeout(() => {
              window.location.href = window.location.href
            }, 1500);
        }
        else
        {
            setLoading(false);
            toasterrormsg(res.message)
        }
        
    }
    // action function end
    useEffect(()=>{
        var admin:any=sessionStorage.getItem("admin");
        setadminData(JSON.parse(admin))
        
          document.title = 'Insayr | Profile Setting' 
       
        getprofile()
        
    },[])

    // api call function start
    const getprofile=async()=>{
        
        var tmp:any=sessionStorage.getItem("admin")
        tmp=JSON.parse(tmp)
        
        var param:any={
            adminId:String(tmp['adminId']),
        }
  
        var response:any=await fetchData("admin/viewProfile",param)
        
        if(response.status=="200")
        {
            
            var data=response.data[0]
            
            setFullName(data['fullName']);
            setCountryCode(data['countryCode'])
            setEmail((data['email']));
            setImageUrl(data['profilePicture'])
            setMobileNumber((data['mobileNumber']))

            tmp['fullName']=data['fullName']
            tmp['mobile_number']=data['mobileNumber']
            tmp['email']=data['email']
            tmp['profilePicture']=data['profilePicture']
            tmp['country_code']=data['countryCode']

            sessionStorage.setItem("admin",JSON.stringify(tmp))

            
        }
        else
        {
            toasterrormsg(response.message)
            
        }
    }
    
  return (
    <>
    <ToastContainer />
      <div className='card mb-5 mb-xl-10'>
        <div
          className='card-header border-0 cursor-pointer'
          role='button'
          data-bs-toggle='collapse'
          data-bs-target='#kt_account_profile_details'
          aria-expanded='true'
          aria-controls='kt_account_profile_details'
        >
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Profile Details</h3>
          </div>
        </div>

        <div id='kt_account_profile_details' className='collapse show'>
          <div className='form'>
            <div className='card-body border-top p-9'>
              {/* <!--begin::Input group--> */}
              <div className="row mb-6">
                  {/* <!--begin::Label--> */}
                  <label className="col-lg-4 col-form-label fw-bold fs-6">Avatar</label>
                  {/* <!--end::Label--> */}
                  {/* <!--begin::Col--> */}
                  <div className="col-lg-8">
                      {/* <!--begin::Image input--> */}
                      <div className="image-input image-input-outline " data-kt-image-input="true">

                          {/* <!--begin::Preview existing avatar--> */}
                          
                          <img id="previewImage" alt='imagepreview' className="image-input-wrapper w-125px h-125px changeimg pointer"  src={image?URL.createObjectURL(image):imageUrl==="" || imageUrl===null?toAbsoluteUrl('/media/default.jpg'):imageUrl} /> 
                          
                          
                          {/* <!--end::Preview existing avatar--> */}
                          {/* <!--begin::Label--> */}
                          <label className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow" data-kt-image-input-action="change" data-bs-toggle="tooltip" title="" data-bs-original-title="Change avatar">
                              <i className="fa fa-edit"></i>
                              {/* <!--begin::Inputs--> */}
                              <input type="file" name="image" id="profileImage" accept=".png, .jpg, .jpeg" style={{"display": "none"}} onChange={(e:any)=>{if(e.target.files[0]!=null && e.target.files[0]!=undefined){setImage(e.target.files[0])}}} />
                              <input type="hidden" name="avatar_remove" />
                              {/* <!--end::Inputs--> */}
                          </label>
                          {/* <!--end::Label--> */}
                      </div>
                      {/* <!--end::Image input--> */}
                      {/* <!--begin::Hint--> */}
                      <div className="form-text" id="validimage">Allowed file types: png, jpg, jpeg.</div>
                      {/* <!--end::Hint--> */}
                  </div>
                  {/* <!--end::Col--> */}
              </div>
              {/* <!--end::Input group--> */}

              <div className="row mb-6">
                  <label className="col-lg-4 col-form-label required fw-bold fs-6">Full Name</label>
                  <div className="col-lg-8 fv-row">
                      <input type="text" name="fullName" className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" placeholder="Full Name" value={fullName} onChange={(e:any)=>setFullName(e.target.value)} />
                      <div className="fv-plugins-message-container invalid-feedback"></div>
                  </div>
              </div>
              
              <div className="row mb-6">
                  <label className="col-lg-4 col-form-label fw-bold fs-6">
                      <span className="required">Mobile Number</span>
                  </label>
                  <div className="col-lg-8 fv-row fv-plugins-icon-container d-lg-flex d-md-flex d-xl-flex align-items-center">
                      
                      
                      <PhoneInput
                          inputClass="form-control form-control-lg form-control-solid w-100"
                          placeholder='Enter Mobile Number'
                          enableSearch={true}
                          value={countryCode+mobileNumber}
                          // country={countryCode}
                          onChange={handleChange}
                      />
                      
                  </div>
              </div>
              <div className="row mb-6">
                  <label className="col-lg-4 col-form-label fw-bold fs-6">
                      <span className="required">Email</span>

                  </label>
                  <div className="col-lg-8 fv-row fv-plugins-icon-container">
                      <input type="tel" name="email" className="form-control form-control-lg form-control-solid" placeholder="Email" value={email} onChange={(e:any)=>setEmail(e.target.value)} />
                      <div className="fv-plugins-message-container invalid-feedback"></div>
                  </div>
              </div>
            </div>

            <div className='card-footer d-flex justify-content-end py-6 px-9'>
              <button type='button' className='btn btn-success monthBtn' disabled={loading} onClick={() => validprofile()}>
                {!loading && 'Save Changes'}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Please wait...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {ProfileDetails}
